var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2093_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 17.4163C13.871 17.4163 17.4154 13.8719 17.4154 9.49967C17.4154 5.12742 13.871 1.58301 9.4987 1.58301C5.12644 1.58301 1.58203 5.12742 1.58203 9.49967C1.58203 13.8719 5.12644 17.4163 9.4987 17.4163Z",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 11.083C6.33203 11.083 7.51953 12.6663 9.4987 12.6663C11.4779 12.6663 12.6654 11.083 12.6654 11.083",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 7.125H7.13292",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7.125H11.8829",
    stroke: "#1A1B32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2093_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile2);
export default __webpack_public_path__ + "static/media/smile-2.d6ccffbb2664b6c1f02bf2d8eac55514.svg";
export { ForwardRef as ReactComponent };